import auth from '../../middlewares/auth';

export const sslRoutes = [
  {
    path: '/ssls',
    component: () =>
      import(/* webpackChunkName: "ssls" */ '../../views/ssls/Ssl'),
    name: 'ssls',
    meta: {
      middleware: [auth],
      requiredPermissions: ['ssl-manage'],
    },
  },
  {
    path: '/ssl/:id',
    component: () =>
      import(/* webpackChunkName: "ssls" */ '../../views/ssls/SslForm'),
    name: 'update-ssl',
    meta: {
      middleware: [auth],
      requiredPermissions: ['ssl-manage'],
    },
  },
  {
    path: '/create-ssl',
    component: () =>
      import(/* webpackChunkName: "ssls" */ '../../views/ssls/SslForm'),
    name: 'create-ssl',
    meta: {
      middleware: [auth],
      requiredPermissions: ['ssl-manage'],
    },
  },
];
